<div class="main-container" @fadeIn>
	<div class="main-form">
		<div class="unregister-header">
			<h3>Delete User Account</h3>
		</div>
		<div class="message-wrapper">The account deletion is a <strong>permanent action</strong> and
			<strong>cannot be undone</strong>.
			Only
			<strong>proceed</strong> if this is the intended action/outcome.
		</div>
		<div class="form-button-container">
			<button class="delete-button" mat-raised-button type="button" color="error" (click)="onDelete()">
				Proceed
			</button>
		</div>
	</div>
</div>